import api from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/sass-loader/dist/cjs.js!./ListView.scss";

var options = {"injectType":"singletonStyleTag","attributes":{"class":"booking-search-box-styles"}};

options.insert = function insertInShadowDOM(element) {
								try {
									const appDOM = document.getElementById("booking-search-box-wrapper");
									const supportsShadowDOM =
										appDOM.shadowRoot === null || typeof appDOM.shadowRoot === "object";

									if (supportsShadowDOM) {
										if (appDOM.shadowRoot === null) {
											appDOM.attachShadow({ mode: "open" });
										}
										appDOM.shadowRoot.appendChild(element);
									} else {
										document.querySelector("head").appendChild(element);
									}
								} catch (e) {
									document.querySelector("head").appendChild(element);
								}
							};
options.singleton = true;

var update = api(content, options);



export default content.locals || {};